import React, { useCallback } from "react";
import { useEffect } from "react";
import { useState } from "react";
import _ from "lodash";

import FormInputTextComponent from "../form-input-text/form-input-text.component";

const FormInputTextAutoCompeleteComponent = ({
  id,
  name,
  placeholder,
  value,
  // options = [],
  onChange,
  onKeyDown,
  threshold = 300,
  isVertical,
  inputIcon,
  handleInputIconClick,
  label,
  isRequired,
  error,
  i,
  inputStyles,
  fetchOptions,
  formatOption,
}) => {
  const [selectedOption, setSelectedOption] = useState(
    value ? { ...value } : {}
  );
  const [options, setOptions] = useState([]);
  const [showOptions, setShowOptions] = useState(false);
  const [optionPanelTimeOut, setOptionPanelTimeOut] = useState();
  const [previousKeyCodeActive, setPreviousKeyCodeActive] = useState();

  const debouncedFetchResults = useCallback(
    _.debounce(async (searchQuery) => {
      if (fetchOptions) {
        const res = await fetchOptions(searchQuery);
        console.log({ res });
        if (searchQuery && res.status) {
          setShowOptions(true);
          const formattedOptions = res.data.map((option) => {
            return {
              name: formatOption ? formatOption(option) : option.name,
              value: option.id,
              data: option,
            };
          });

          setOptions(formattedOptions);
        } else {
          setShowOptions(false);
          setOptions([]);
        }
      }
    }, 300),
    []
  );

  const handleChange = (value) => {
    console.log( 'coming here');
    const updatedValue = {
      ...selectedOption,
      name: value,
      value: null,
    };
    setSelectedOption(value ? updatedValue : {});

    if (!value || value == ""){
      setShowOptions(false);
      onChange(value ? updatedValue : "")
    } else {
      setShowOptions(false);
      onChange(value ? updatedValue : "")
    }
    // if (optionPanelTimeOut) clearTimeout(optionPanelTimeOut);
    // const optionTimer = setTimeout(() => {
    //   if (onChange) onChange(value ? updatedValue : "");
    // }, threshold);

    // setOptionPanelTimeOut(optionTimer);
    debouncedFetchResults(value);
  };

  const handleKeyDown = ({ keyCode }) => {
    if (onKeyDown) onKeyDown({ keyCode: keyCode });

    if (previousKeyCodeActive > -1) {
      // console.log("coming here");
      const previousElement = document.getElementById(
        id + "-option-" + options[previousKeyCodeActive].value
      );

      if (previousElement) {
        previousElement.classList.remove("keydown-active");
      }
    }

    let swapStatus = false;
    // INFO: Arrow Up
    if (keyCode === 38) {
      for (let i = options.length; i >= 0; i--) {
        // console.log({ i, previousKeyCodeActive });
        if (i < previousKeyCodeActive) {
          const element = document.getElementById(
            id + "-option-" + options[i].value
          );
          if (element && !swapStatus) {
            // console.log("coming here 2");
            element.classList.add("keydown-active");
            setPreviousKeyCodeActive(i);
            swapStatus = true;
          }
        }
      }
    }

    // INFO: Arrow Down
    if (keyCode === 40) {
      // console.log({ previousKeyCodeActive });

      for (let i = 0; i < options.length; i++) {
        if (i > previousKeyCodeActive) {
          const element = document.getElementById(
            id + "-option-" + options[i].value
          );
          if (element && !swapStatus) {
            element.classList.add("keydown-active");
            setPreviousKeyCodeActive(i);
            swapStatus = true;
          }
        }
      }
    }

    if (keyCode === 13 && !selectedOption.value) {
      handleOptionClick(options[previousKeyCodeActive]);
    }
  };

  const handleOptionClick = (option) => {
    console.log(option);

    const updatedValue = {
      ...selectedOption,
      name: option.name,
      value: option.value,
      data: option?.data || null,
    };

    setShowOptions(false);
    setSelectedOption(updatedValue);
    onChange(updatedValue);
    setPreviousKeyCodeActive(-1);
  };

  const handleFocus = () => {
    setPreviousKeyCodeActive(-1);
  };

  useEffect(() => {
    const suggestionStatus =
      options.length > 0 && selectedOption.name && !selectedOption.value
        ? true
        : false;
    // console.log({ suggestionStatus, options, selectedOption });
    setShowOptions(suggestionStatus);
    setPreviousKeyCodeActive(-1);
  }, [options, selectedOption]);

  useEffect(() => {
  //  console.log("changing",value);
    if (value && typeof value === 'object' && value.name == "-") {
      setShowOptions(false);
      setSelectedOption({name:"", value:"", data:null});
    } else if(value) {
      setSelectedOption({ ...value });
    }
  }, [value]);
 
  return (
    <>
      <div className="col-12">
        <div
          className={`${isVertical ? "" : "mb-1 row "} ${
            inputIcon ? "input-group" : ""
          }`}
        >
          {label && (
            <div className={isVertical ? "col-12" : "col-2"}>
              <label className="col-form-label">
                {label}
                {isRequired && <> * </>}
              </label>
            </div>
          )}

          <div className={isVertical ? "col-12" : "col-10"}>
            <div className={inputIcon && !error ? "input-group" : ""}>
              <div className="autocomplete" style={{ width: "100%" }}>
                <FormInputTextComponent
                  isVertical
                  id={id}
                  name={name}
                  value={selectedOption.name}
                  placeholder={placeholder}
                  onChange={handleChange}
                  onKeyDown={(e) => handleKeyDown(e)}
                  onFocus={handleFocus}
                  inputIcon={inputIcon}
                  handleInputIconClick={handleInputIconClick}
                  error={error}
                  inputStyles={inputStyles ? inputStyles : {}}
                />

                <div
                  className={`autocomplete-items ${
                    showOptions > 0 ? "" : "hidden"
                  } ${i ? "wrap-studio" : ""}`}
                  style={{
                    backgroundColor: i ? "#fff" : "",
                    border: i ? "2px solid #04a9ff" : "",
                    padding: i ? "2px" : "",
                   
                  }}
                >
                  {options.map((option) => (
                    <div
                      id={`${id}-option-${option.value}`}
                      onClick={() => handleOptionClick(option)}
                      style={
                        i
                          ? {
                              background: "#f3f3f3",
                              marginTop: "4px",
                              marginBottom: "5px",
                            }
                          : {
                              color: "#fff",
                            }
                      }
                    >
                      {option.name}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormInputTextAutoCompeleteComponent;
